module.exports = __webpack_public_path__ + "img/组 11.02ab7422.png";